import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { Toast } from "@/utils";
import {
  deleteSerialGPS,
  getPrototypeRegistrationList,
  getSerialGPSByPrototypeRegistrationId,
} from "@/request/view/prototypeManagement";
import { useTable } from "@/views/notice/serve/table";


export default /*#__PURE__*/_defineComponent({
  __name: 'locationForm',
  setup(__props, { expose: __expose }) {

const {
  requestConfig,
  table,
  requestPayload,
  initPayload,
  getListData,
  searchData,
  deleteRecords,
  hanldeUpdatePageNum,
} = useTable();

const visible = ref(false);

requestConfig.pull_fn = getSerialGPSByPrototypeRegistrationId;
requestConfig.delete_fn = deleteSerialGPS;

const pagination = ref({
  current: 1,
  defaultPageSize: 10,
  total: 0,
  pageSizeOptions: ["10", "20", "50", "100"],
  showTotal: (total) => `共 ${total} 条`,
  showQuickJumper: true,
  showSizeChanger: true,
  onChange: (page, pageSize) => {
    changePagination(page);
  },
});
const changePagination = (page) => {
  pagination.value.current = page;
};

initPayload({
  prototypeRegistrationId: null,
});

const columns = [
  { title: "日期", dataIndex: "localDate", align: "center", width: "140px" },
  { title: "地址", dataIndex: "address", align: "center", width: "600px" },
];

const rowkey = ref([]);

const deleteDisabled = computed(() => rowkey.value.length === 0);

const rowSelection = {
  onChange: (selectedRowKeys) => {
    rowkey.value = selectedRowKeys;
  },
};

const showModal = async (id) => {
  requestPayload.prototypeRegistrationId = id;
  await getListData();
  if (table.data.length === 0) {
    return Toast("warning", "无定位数据", 3);
  }
  visible.value = true;
};

const handleDeleteLocation = () => {
  deleteRecords(rowkey.value, { title: "确认删除" }).then((res) => {
    getListData();
  });
};

__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "位置管理",
    footer: null,
    width: "900px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "danger",
        size: "small",
        onClick: handleDeleteLocation,
        disabled: deleteDisabled.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("删除")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_table, {
        "data-source": _unref(table).data,
        bordered: "",
        columns: columns,
        "row-selection": rowSelection,
        rowKey: "id",
        style: {"margin-top":"10px"},
        pagination: pagination.value
      }, null, 8, ["data-source", "pagination"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})